/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   buildStaticImageUrl
 */

import { buildStaticImageUrl } from '@zcode/nr-utils'
export default buildStaticImageUrl
